/**
 * @fileoverview POST handler for the "/companies/:company_id/developers/csv_export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersCsvExportCacheKeys } from "./constants";
import type { PostCompaniesCompanyIdDevelopersCsvExportProps } from "./types";

export const postDevelopersCsvExport = reactQueryMutationAdapter(
  companiesCompanyIdDevelopersCsvExportCacheKeys,
  (props: PostCompaniesCompanyIdDevelopersCsvExportProps): Promise<{}> => {
    return fetch(`/companies/${props.companyId}/developers/csv_export`, "POST", props);
  }
);
